import { Grid, Typography, Box, TextField } from "@mui/material"
import { useEffect } from "react"
import { usePasswordRecoveryService } from "../../../../use-cases/auth/usePasswordRecoveryService"
import { useAppSelector, useAppDispatch } from "../../../hooks/store-hooks"
import { resetRequestNewPasswordFormState } from "../../../../application/states/auth"

export const RequestNewPasswordForm = () => {
  const dispatch = useAppDispatch()
  const { setRequestNewPasswordFormEmail } = usePasswordRecoveryService()
  const requestNewPasswordForm = useAppSelector((state) => state.auth.requestNewPasswordForm)

  useEffect(() => {
    dispatch(resetRequestNewPasswordFormState())
  }, [dispatch])

  return <>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h5" component="h1" align="center" color="primary" fontWeight="bold">
          Recuperar senha
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" component="p" align="center">
          Para trocar sua senha, insira o endereço de e-mail associado à sua conta no campo de texto abaixo e clique em "Próximo". Em seguida, enviaremos um e-mail com um código de verificação para confirmar sua identidade. Quando receber o código, insira-o no campo fornecido na próxima página e crie uma nova senha para a sua conta.
        </Typography>
        <Box mt={3}>

          <Typography variant="body1" component="p" align="center" fontWeight="bold">
            Lembre-se de seguir todas as instruções fornecidas pelo sistema para garantir a segurança da sua conta. Se você tiver problemas para recuperar sua senha, entre em contato com o suporte ao cliente para obter ajuda adicional.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TextField
          value={requestNewPasswordForm.fields.email}
          onChange={(e) => {
            setRequestNewPasswordFormEmail({
              email: e.target.value
            })
          }}
          error={Boolean(requestNewPasswordForm.touched && requestNewPasswordForm.errors.find(item => item.key === 'email'))}
          helperText={
            requestNewPasswordForm.errors.find(item => item.key === 'email')?.message
          }
          name="email"
          fullWidth
          id="email"
          label="E-mail"
        />
      </Grid>
    </Grid>
  </>
}